const getCookie = (cookieName) => {
  if (!cookieName) return undefined

  const cookies = document.cookie.split(";")
  const gtmCookie = cookies.find((row) => row.trim().startsWith(`${cookieName}=`))
  const gtmCookieValue = gtmCookie?.split("=")[1]
  return gtmCookieValue ? decodeURIComponent(gtmCookieValue) : undefined
}

export default getCookie
